
if (!customElements.get("custom-dropdown")) {
  class CustomDropdown extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.contentWrapper = null;
      this.allOpenedDropdowns = null;
      this.OPEN_ONE_AT_TIME = this.hasAttribute('one-at-time');
      this.ENABLE_ANIMATION = this.hasAttribute('animate');
      this.CONTENT_OFFSET = this.getAttribute('content-offset');
    }

    connectedCallback() {
      this.trigger = this.querySelector('[action-trigger]');
      this.contentWrapper = this.querySelector('[content]');
      this.attachEvents();
    }

    attachEvents() {
      this.trigger.addEventListener('click', () => this.toggleOptions());
    }

    calculateOptionsContainerHeight(select) {
      const height = select.contentWrapper.scrollHeight;
      if (select.hasAttribute('open')) {
        select.contentWrapper.style.height = `${height + Number(this.CONTENT_OFFSET)}px`;
      } else {
        select.contentWrapper.style.height = '0';
      }
    }

    open(dropdown) {
      dropdown.setAttribute('open', '');
      if (this.ENABLE_ANIMATION) this.calculateOptionsContainerHeight(dropdown);
    }

    close(dropdown) {
      dropdown.removeAttribute('open');
      if (this.ENABLE_ANIMATION) this.calculateOptionsContainerHeight(dropdown);
    }

    toggleOptions() {
      if (this.OPEN_ONE_AT_TIME) {
        this.allOpenedDropdowns = document.querySelectorAll(this.classList);
        this.allOpenedDropdowns.forEach(dropdown => {
          if (dropdown != this) this.close(dropdown);
        });
      }

      this.hasAttribute('open')
        ? this.close(this)
        : this.open(this);
    }
  }

  customElements.define('custom-dropdown', CustomDropdown);
}